import { Box, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import type { FaultData, VisitFaultModel } from '../../models';

export const FaultStatus = ({
  visitFault: { isResolved, createdAt, resolvedAt }
}: {
  visitFault: VisitFaultModel | FaultData;
}) => {
  const [title, setTitle] = useState<string>('');
  const [subTitle, setSubtitle] = useState<string>('');
  const [days, setDays] = useState<number>();

  useEffect(() => {
    if (isResolved) {
      setDays(getResolvedAfterDays());
    } else {
      setDays(getUnresolvedForDays());
    }
    //todo:v2-changes
  }, []);

  useEffect(() => {
    if (days === undefined) {
      return;
    }
    if (isResolved) {
      if (days < 1) {
        setTitle('Resolved');
        setSubtitle('');
      } else {
        setTitle(`Resolved after`);
        setSubtitle(`${days} day${days > 1 ? 's' : ''}`);
      }
    } else {
      if (days < 1) {
        setTitle('Unresolved');
        setSubtitle('');
      } else {
        setTitle(`Unresolved for`);
        setSubtitle(`${days} day${days > 1 ? 's' : ''}`);
      }
    }
    //todo:v2-changes
  }, [days]);

  const getResolvedAfterDays = () => {
    if (!createdAt || !resolvedAt) throw new Error('Missing Fault Resolved Params');
    return Math.floor(DateTime.fromISO(resolvedAt).diff(DateTime.fromISO(createdAt), 'days').days);
  };

  const getUnresolvedForDays = () => {
    if (!createdAt) throw new Error('Missing Fault Resolved Params');
    return Math.floor(Math.abs(DateTime.fromISO(createdAt).diffNow('days').days));
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box
        sx={{
          padding: 1.2,
          backgroundColor: isResolved ? '#7FD3D3' : '#F27FBE',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          borderRadius: '12px'
        }}
      >
        <Typography variant={'body1'} component={'span'}>
          {title}
        </Typography>
        <Typography variant={'h4'} component={'span'} sx={{ fontWeight: 'bold' }}>
          {subTitle}
        </Typography>
      </Box>
    </Box>
  );
};
